/* @ngInject */
function countryCodeToName(countries) {
  return function (code) {
    return countries.find((countryObject) => countryObject.code === code).name;
  };
}

export default countryCodeToName;
